<script>
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  watch: {
    chartdata: function (newVal, oldVal) {
      this.renderChart(newVal, this.options)
    },
    options: function (newVal, oldVal) {
      this.renderChart(this.chartdata, newVal)
    }
  },
  mounted () { 
    this.renderChart(this.chartdata, this.options)
  }
}
</script>
